import { FollowersResponseDataDto } from "../dto/response/followers.response.dto";
import { FollowingResponseDataDto } from "../dto/response/following.response.dto";
import { StreamerFollow } from "../model/streamer-follow.model";

export function toStreamerFollers(
  dto: FollowersResponseDataDto,
): StreamerFollow[] {
  return dto.data.map(
    (follow) =>
      ({
        id: follow.id,
        followerId: follow.followerId,
        streamerId: follow.streamerId,
        followedAt: follow.followedAt,
        isActive: follow.isActive,
        followerName: follow.followerName}) as StreamerFollow,
  );
}

export function toStreamerFolowings(
  dto: FollowingResponseDataDto,
): StreamerFollow[] {
  return dto.data.map(
    (follow) =>
      ({
        id: follow.id,
        followerId: follow.followerId,
        streamerId: follow.streamerId,
        followedAt: follow.followedAt,
        isActive: follow.isActive,
        followerName: follow.followerName,
        streamerName: follow.streamerName,
        streamerAtname: follow.streamerAtname,
        streamerImage: follow.streamerImage}) as StreamerFollow,
  );
}
